import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'src/app/core/gaurds/auth.gaurd';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { ErrorComponent } from './shared/error/error.component';

const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('src/app/features/administrador/login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'home',
        loadChildren: () => import('src/app/features/web/home/home.module').then(m => m.HomeModule)
    },

    {
        path: 'dobledeluxe',
        loadChildren: () => import('src/app/features/web/dobledeluxe/dobledeluxe.module').then(m => m.DobleDeluxeModule)
    },
    {
        path: 'cancelarsuscripcion',
        loadChildren: () => import('src/app/features/web/cancelarSub/cancelarsub.module').then(m => m.CancelarSubModule)
    },
    {
        path: 'doblesuperior',
        loadChildren: () => import('src/app/features/web/doblesuperior/doblesuperior.module').then(m => m.DobleSuperiorModule)
    },
    {
        path: 'main',
        component: LayoutComponent,
        children: [{
            path: 'reservas',
            loadChildren: () => import('src/app/features/administrador/reservas/reservas.module').then(m => m.ReservasModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'aboutus',
            loadChildren: () => import('src/app/features/administrador/aboutus/aboutus.module').then(m => m.AboutUsModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'clientes',
            loadChildren: () => import('src/app/features/administrador/clientes/clientes.module').then(m => m.ClientesModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'habitaciones',
            loadChildren: () => import('src/app/features/administrador/habitacionesAdm/habitacionesAdm.module').then(m => m.HabitacionesModule),
            canActivate: [AuthGuard]
        },
        
        {
            path: 'tipohabitaciones',
            loadChildren: () => import('src/app/features/administrador/tipohabitaciones/tipohabitaciones.module').then(m => m.TipoHabitacionesModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'productos',
            loadChildren: () => import('src/app/features/administrador/productos/productos.module').then(m => m.ProductosModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'pedidos',
            loadChildren: () => import('src/app/features/administrador/pedidos/pedidos.module').then(m => m.PedidosModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'contactus',
            loadChildren: () => import('src/app/features/administrador/contactus/contactus.module').then(m => m.ContactUsModule),
            canActivate: [AuthGuard]
        }]
    },
    {
        path: 'error',
        component: ErrorComponent,
        //loadChildren: () => import('src/app/shared/error/error.module').then(m => m.ErrorModule)
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }